import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {SendGatewayDevicesConfigCB} from "../../ope/gateway/SendGatewayDevicesConfigCB";
import {PutGatewayCB} from "../../ope/gateway/PutGatewayCB";
import {PutGatewayLegacyCB} from "../../ope/gateway/PutGatewayLegacyCB";
import {DelGatewayCB} from "../../ope/gateway/DelGatewayCB";
import {AssignGatewayCB} from "../../ope/gateway/AssignGatewayCB";
import {ReplaceGatewayCB} from "../../ope/gateway/ReplaceGatewayCB";
import {DismissGatewayCB} from "../../ope/gateway/DismissGatewayCB";
import {GetFlashedGatewaysCB} from "../../ope/gateway/GetFlashedGatewaysCB";
import {GetNetInterfacePasswordCB} from "../../ope/gateway/GetNetInterfacePasswordCB";

@Injectable({
  providedIn: 'root'
})
export class GatewayOpeService extends BaseOPEService {

  // Updates go through the pending-config draft; creation writes reg_gateway directly.
  public putGateway(cb: PutGatewayCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putGatewayLegacy(cb: PutGatewayLegacyCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delGateway(cb: DelGatewayCB): Promise<any> {
    return this.execOPE(cb);
  }

  // public provisionGateway(cb: ProvisionGatewayCB): Promise<any> {
  //   return this.execOPE(cb);
  // }
  public sendGatewayDevicesConfig(cb: SendGatewayDevicesConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public assignGateway(cb: AssignGatewayCB): Promise<any> {
    return this.execOPE(cb);
  }

  public replaceGateway(cb: ReplaceGatewayCB): Promise<any> {
    return this.execOPE(cb);
  }

  public dismissGateway(cb: DismissGatewayCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getFlashedGateways(cb: GetFlashedGatewaysCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getNetInterfacePassword(cb: GetNetInterfacePasswordCB): Promise<any> {
    return this.execOPE(cb);
  }
}
